var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessageBubble(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.86814 1.67715H3.90594C2.87569 1.67715 2.36057 1.67715 1.96706 1.87765C1.62093 2.05402 1.33951 2.33543 1.16315 2.68157C0.962646 3.07507 0.962646 3.5902 0.962646 4.62045V7.80901C0.962646 8.37926 0.962646 8.66438 1.02533 8.89831C1.19543 9.53313 1.69128 10.029 2.32609 10.1991C2.56002 10.2618 2.84515 10.2618 3.41539 10.2618V11.6939C3.41539 12.0206 3.41539 12.184 3.48237 12.2679C3.54062 12.3408 3.62895 12.3833 3.72232 12.3832C3.82968 12.3831 3.95725 12.281 4.21238 12.0769L5.67511 10.9067C5.97392 10.6677 6.12333 10.5482 6.28969 10.4632C6.4373 10.3878 6.59441 10.3326 6.75678 10.2993C6.93978 10.2618 7.13111 10.2618 7.51378 10.2618H8.44352C9.47377 10.2618 9.98889 10.2618 10.3824 10.0613C10.7285 9.88489 11.0099 9.60348 11.1863 9.25734C11.3868 8.86384 11.3868 8.34871 11.3868 7.31846V7.19583M11.4612 1.60276C12.1796 2.32115 12.1796 3.4859 11.4612 4.20429C10.7428 4.92268 9.57807 4.92268 8.85968 4.20429C8.14128 3.4859 8.14128 2.32115 8.85968 1.60276C9.57807 0.884367 10.7428 0.884367 11.4612 1.60276Z",
    stroke: "#FF0082",
    strokeWidth: 1.22637,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageBubble);
export default __webpack_public_path__ + "static/media/message-bubble.078f17237fa41aff65ffa1582f0ba0b2.svg";
export { ForwardRef as ReactComponent };